import * as React from 'react';
import Box from '@mui/material/Box';
import { Title } from '../../../components/Title';
import { TextBlack } from '../../../components/TextBlack';
import { TextGreen } from '../../../components/TextGreen';

//import tyrol from '../../images/GemeindeberatungZertifizierung.png'

export default function Wastunwir() {

  return (
    <Box className='maintextbox'>

      <Title title="what_we_do" variant="title"></Title>

      <TextBlack text='what_we_do_1'></TextBlack>

      <TextGreen text='what_we_do_2'></TextGreen>

      <TextBlack text='what_we_do_3'></TextBlack>

      <TextBlack text='what_we_do_4'></TextBlack>

    {/* 
	    <img src={tyrol} alt="Overview" className="centered-picture" />
    */}
    </Box>


  );
}